"use client";

import { Button } from "@/components/ui/button";
import { useTour } from "@/context/TourContext";
import React from "react";

interface TourWelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartTour: () => void;
}

export const TourWelcomeModal: React.FC<TourWelcomeModalProps> = ({
  isOpen,
  onStartTour,
}) => {
  const { startAlternativeTour } = useTour();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative mx-4 w-full max-w-lg">
        {/* Modal Container with Gradient Background */}
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-b from-orange-300 to-orange-500 p-10 shadow-2xl">
          {/* Content */}
          <div className="relative z-10 text-center text-white">
            {/* Title with Confetti */}
            <h1 className="mb-6 text-4xl font-bold leading-tight">
              ¡Te damos la bienvenida a Orquesti! 🎉
            </h1>

            {/* Description */}
            <p className="mb-10 text-white text-xl leading-relaxed opacity-95">
              Te ofrecemos un tour guiado para que conozcas todas las
              funcionalidades y aproveches al máximo la plataforma.
            </p>

            {/* Buttons */}
            <div className="flex justify-center gap-4">
              <Button
                onClick={startAlternativeTour}
                variant="white"
                size="lg"
                // className="bg-white"
                // className="flex-1 rounded-xl bg-blue-200 border-blue-400 text-blue-700 hover:bg-blue-500 hover:text-white hover:border-blue-300 transition-all duration-200 py-3 text-lg font-medium"
              >
                Ahora no
              </Button>
              <Button
                onClick={onStartTour}
                size="lg"
                // className="flex-1 rounded-xl hover:bg-gray-50 hover:text-blue-800 transition-all duration-200 py-3 text-lg font-medium shadow-lg"
              >
                ¡Comenzar Tour!
              </Button>
            </div>
          </div>

          {/* Decorative Elements */}
          <div className="absolute -top-6 -right-6 h-32 w-32 rounded-full bg-white/15 blur-sm"></div>
          <div className="absolute -bottom-8 -left-8 h-40 w-40 rounded-full bg-white/10 blur-sm"></div>
          <div className="absolute top-1/2 -left-4 h-24 w-24 rounded-full bg-white/8 blur-sm"></div>
          <div className="absolute top-1/4 -right-2 h-16 w-16 rounded-full bg-white/12 blur-sm"></div>
        </div>
      </div>
    </div>
  );
};
